export default {
  NPS: {
    widget_button_labels: {
      not_likely: 'Not at all likely',
      likely: 'Extremely likely'
    }
  },
  SAT: {
    widget_button_labels: [
      { id: 1, label: 'Very dissatisfied', order_no: 1 },
      { id: 2, label: 'Somewhat dissatisfied', order_no: 2 },
      { id: 3, label: 'Neither satisfied nor dissatisfied', order_no: 3 },
      { id: 4, label: 'Somewhat satisfied', order_no: 4 },
      { id: 5, label: 'Very satisfied', order_no: 5 }
    ]
  },
  ES: {
    widget_button_labels: [
      { id: 1, label: 'Disagree', order_no: 1 },
      { id: 2, label: 'Somewhat disagree', order_no: 2 },
      { id: 3, label: 'Neither agree nor disagree', order_no: 3 },
      { id: 4, label: 'Somewhat agree', order_no: 4 },
      { id: 5, label: 'Agree', order_no: 5 }
    ]
  }
}
